//Deps
import { textStyles } from "~/styleguide/typography";
import { createComponent } from "react-fela";
import { buttons } from "~/styleguide/links";
import { getVideoSource } from "~/modules/video";
import { combineRules } from "fela";
import { fluid } from "~/styleguide/utils";
import tinyColor from "tinycolor2";

//Components
import WordpressLink, {
    getLinkFromRelationship
} from "~/components/global/links";

export default function MarqueeCTA({
    type,
    link,
    link_label,
    link_type,
    link_content,
    video_embed,
    video_button_label,
    theme,
    form_cta_label,
    isShowingForm,
    textTheme,
    toggle,
    setIsShowingForm,
    hubspot_form_id,
    extend,
    secondary_link,
    secondary_link_type,
    secondary_link_url,
    secondary_link_content
}) {
    const parsedLink = getLinkFromRelationship(link_type, link_content, link);

    const parsedSecondaryLink =
        secondary_link === "link"
            ? getLinkFromRelationship(
                  secondary_link_type,
                  secondary_link_content,
                  secondary_link_url
              )
            : null;

    return (
        <ButtonWrapper extend={extend}>
            {/* Primary CTA Button */}
            {type === "page" && parsedLink && parsedLink.url && link_label && (
                <WordpressLink
                    className="CTA-1"
                    layout="button"
                    url={parsedLink.url}
                    slug={parsedLink.slug}
                    size="large"
                    label={link_label}
                    theme={theme}
                    style={marqueeButtonStyle}
                ></WordpressLink>
            )}

            {/* Secondary CTA link */}
            {type === "page" &&
                parsedSecondaryLink &&
                parsedSecondaryLink.url &&
                video_button_label && (
                    <WordpressLink
                        className="CTA-2"
                        layout="button"
                        url={parsedSecondaryLink.url}
                        slug={parsedSecondaryLink.slug}
                        size="large"
                        label={video_button_label}
                        theme={theme}
                        outline={true}
                        backgroundColor={theme.primary}
                        extend={combineRules(marqueeButtonStyle, {
                            ...textTheme,
                            whenActive: {
                                backgroundColor:
                                    tinyColor(theme.primary)
                                        .lighten(14.5)
                                        .toString() + "!important"
                            }
                        })}
                    ></WordpressLink>
                )}

            {/* Video Modal Button */}
            {type === "page" &&
                secondary_link === "video" &&
                video_embed &&
                video_button_label && (
                    <ModalButton
                        onClick={toggle}
                        href={getVideoSource(video_embed)}
                        target="_blank"
                        rel="noopener noreferrer"
                        extend={combineRules(marqueeButtonStyle, {
                            ...textTheme
                        })}
                        backgroundColor={theme.primary}
                        colorTheme={theme}
                        layout="button"
                        size="large"
                        outline={true}
                    >
                        <span>{video_button_label}</span>
                    </ModalButton>
                )}

            {/* HubSpot form when `library` type */}
            {hubspot_form_id && type === "library" && !isShowingForm && (
                <FormCTAButton
                    size="large"
                    layout="button"
                    colorTheme={theme}
                    backgroundColor={theme.primary}
                    extend={{ ...textTheme }}
                    onClick={event => {
                        if (event && event.preventDefault) {
                            event.preventDefault();
                        }
                        setIsShowingForm(true);
                    }}
                >
                    <span>{form_cta_label}</span>
                </FormCTAButton>
            )}
        </ButtonWrapper>
    );
}

const ButtonWrapper = createComponent({
    marginTop: 40
});

const marqueeButtonStyle = {
    extend: [fluid("margin-left", { max: 20, min: 8 })],
    maxWidthTablet: {
        marginTop: "20px"
    }
};

const FormCTAButton = createComponent(
    ({ layout, colorTheme, size, backgroundColor }) => ({
        extend: [buttons({ layout, colorTheme, size, backgroundColor })]
    }),
    "a",
    ["onClick", "size"]
);

const ModalButton = createComponent(
    ({ layout, size, outline, colorTheme, backgroundColor }) => ({
        userSelect: "none",
        ...textStyles.paragraphLarge,
        whenActive: {
            backgroundColor:
                tinyColor(colorTheme.primary)
                    .lighten(14.5)
                    .toString() + "!important"
        },
        extend: [
            buttons({ layout, size, outline, colorTheme, backgroundColor })
        ]
    }),
    "a",
    ["onClick", "_target", "href", "rel"]
);
